import { Button } from 'src/components/atoms';
import { Accordion } from 'src/components/molecules';
import {
  AccordionHeader,
  AccordionTitle,
} from 'src/components/molecules/Accordion/Accordion.styles';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const LinkedCaseAccordion = styled(Accordion)`
  padding: 12px;

  ${AccordionHeader} {
    padding: 0;
    overflow: hidden;
  }
`;

export const LinkedCasesContainer = styled.div`
  margin-top: 10px;
  padding: 12px;
`;

export const LinkedCaseTitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const LinkedCaseAccordionTitle = styled(AccordionTitle)`
  margin-left: 10px;
  font-weight: 600;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
`;

export const LinkedCaseItems = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
  padding-top: 8px;
`;

export const LinkedCaseButtonContainer = styled.div`
  margin-top: 10px;
`;

export const LinkMoreCaseButton = styled(Button)`
  background-color: transparent;
  border: 1px solid
    ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N400
        : props.theme.atlas.semantic.color.outline.default};
`;

export const StyledLinkType = styled.span`
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N700
      : props.theme.atlas.semantic.color.type.muted};
  margin-left: 4px;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
`;

export const StyledLinkId = styled.span`
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  margin-right: 4px;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
`;
